import VisualCategoryHeaderLinks from "./VisualCategoryHeaderLinks";
import TextCategoryHeaderLinks from "./TextCategoryHeaderLinks";
import useVisualCategoryHeaderLinks from "./useVisualCategoryHeaderLinks";

const ConnectedCategoryHeaderLinks = props => {
  const CategoryHeaderLinksComponent = useVisualCategoryHeaderLinks()
    ? VisualCategoryHeaderLinks
    : TextCategoryHeaderLinks;

  return <CategoryHeaderLinksComponent {...props} />;
};

export default ConnectedCategoryHeaderLinks;
